const WarningStrings = {
  PropertyExists: "Property {0} already exists.",
  PropertyNotExists: "Property {0} does not exists.",
  PasscodeExists: "Passcode {0} already exists.",
  PasscodeNotExists: "Passcode {0} does not exists.",
}

export default WarningStrings;


// WEBPACK FOOTER //
// ./src/strings/en/warning.js